import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InfoIcon from '@material-ui/icons/Info';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import PeopleIcon from '@material-ui/icons/People';
import EmpresaRegisterInfo from './components/EmpresaRegisterInfo';
import Box from '@material-ui/core/Box';
import EmpresaToolbar from './components/EmpresaRegisterToolbar';
import AppBar from '@material-ui/core/AppBar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import EmpresaRegisterContacts from './components/EmpresaRegisterContacts/EmpresaRegisterContacts';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import EmpresaRegisterUsers from './components/EmpresaRegisterUsers';
import { isAuthenticated } from '../../helpers/authenticate';
import { ValidatorForm } from 'react-material-ui-form-validator';
const timeout = ServiceValues.timeout;




const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  toolbar: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}));
function EmpresaRegister({history}) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [empresa, setEmpresa] = useState(history.location.state.empresa);
  const [edicao, setEdicao] = useState(history.location.state.edicao);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box
          p={3}
        >
          {children}
        </Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }

  async function saveEmpresa() {
    if(edicao){
      try{
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        empresa.cnpj = empresa.cnpj.replace('.', "");
        empresa.cnpj = empresa.cnpj.replace('.', "");
        empresa.cnpj = empresa.cnpj.replace('/', "");
        empresa.cnpj = empresa.cnpj.replace('-', "");
        const empresa_post = {
          razaoSocial: empresa.razaoSocial,
          nomeFantasia: empresa.nomeFantasia,
          cnpj: empresa.cnpj,
          inscricaoEstadual: empresa.inscricaoEstadual,
          inscricaoMunicipal: empresa.inscricaoMunicipal,
          email: empresa.email,
          enderecos: empresa.enderecos,
          telefones: empresa.telefones,
          usuarios: empresa.usuarios
        };
        const dados = await api.put(`empresas/${empresa.idEmpresa}`, empresa_post);
        if(dados.data.isSuccess){
          setMessageSnack('Empresa cadastrada com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/empresa-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          // history.push('/empresa-list/');
        }
      }
      catch (e) {
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    else{
      try{
        let usuarios = [];
        empresa.usuarios.map((usuario, index) => {
          usuarios.push({
            idUsuario: usuario.idUsuario
          });
        });

        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        empresa.cnpj = empresa.cnpj.replace('.', "");
        empresa.cnpj = empresa.cnpj.replace('.', "");
        empresa.cnpj = empresa.cnpj.replace('/', "");
        empresa.cnpj = empresa.cnpj.replace('-', "");
        const empresa_post = {
          razaoSocial: empresa.razaoSocial,
          nomeFantasia: empresa.nomeFantasia,
          cnpj: empresa.cnpj,
          inscricaoEstadual: empresa.inscricaoEstadual,
          inscricaoMunicipal: empresa.inscricaoMunicipal,
          email: empresa.email,
          enderecos: empresa.enderecos,
          telefones: empresa.telefones,
          usuarios: usuarios
        };
        const dados = await api.post('empresas/', empresa_post);
        if(dados.data.isSuccess){
          setMessageSnack('Empresa cadastrada com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/empresa-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          // history.push('/empresa-list/');
        }
      }
      catch (e) {
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    console.log(empresa);
  }


  return (
    <ValidatorForm
      autoComplete="off"
      onSubmit={saveEmpresa}
    >
      <div>
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <EmpresaToolbar
          className={classes.toolbar}
          saveEmpresa={saveEmpresa}
          history={history}
        />
        <Paper className={classes.root}>
          <AppBar position="static" color="inherit">

            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="Informações Gerais" icon={<InfoIcon />} {...a11yProps(0)} />
              <Tab label="Contatos" icon={<ContactPhoneIcon />} {...a11yProps(1)} />
              <Tab label="Usuários" icon={<PeopleIcon />} {...a11yProps(2)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <EmpresaRegisterInfo
              empresa={empresa}
              setEmpresa={setEmpresa}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <EmpresaRegisterContacts
              empresa={empresa}
              setEmpresa={setEmpresa}
              showMessageSnack={showMessageSnack}
              setShowMessageSnack={setShowMessageSnack}
              messageSnack={messageSnack}
              setMessageSnack={setMessageSnack}
              typeSnack={typeSnack}
              setTypeSnack={setTypeSnack}
              edicao={edicao}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <EmpresaRegisterUsers
              empresa={empresa}
              setEmpresa={setEmpresa}
              showMessageSnack={showMessageSnack}
              setShowMessageSnack={setShowMessageSnack}
              messageSnack={messageSnack}
              setMessageSnack={setMessageSnack}
              typeSnack={typeSnack}
              setTypeSnack={setTypeSnack}
              edicao={edicao}
            />
          </TabPanel>

        </Paper>
      </div>
    </ValidatorForm>

  );
};

export default EmpresaRegister;
